import { AlertTriangle, RotateCw } from "lucide-react"
import { Button } from "../../ui"
import { HScroll } from "procurement/design/components/HScroll"

// Small presentational pieces shared by the manager Approval Inbox and Order
// Review screens. Kept together so later procurement stages can reuse them.

// KPI card — label + big value; `danger` paints the value red (overdue > 0).
export const Kpi = ({ label, value, danger, loading }) => (
  <div className="pc-kpi">
    <div className="pc-kpi-label">{label}</div>
    {loading ? (
      <div className="pc-skel" style={{ height: 26, width: 64, marginTop: 8 }} />
    ) : (
      <div className={`pc-kpi-value${danger ? " pc-kpi-value--danger" : ""}`}>
        {value}
      </div>
    )}
  </div>
)

// Full-width error state with a Retry action. Render inside a <Card> body.
export const ErrorState = ({
  title = "Something went wrong",
  message = "We couldn't load this right now. Please try again.",
  onRetry,
}) => (
  <div className="pc-errcard">
    <div className="pc-errcard-ico">
      <AlertTriangle aria-hidden />
    </div>
    <div className="pc-empty-title">{title}</div>
    <div className="pc-empty-text">{message}</div>
    {onRetry && (
      <div style={{ marginTop: 12 }}>
        <Button variant="secondary" size="sm" leftIcon={<RotateCw aria-hidden />} onClick={onRetry}>
          Retry
        </Button>
      </div>
    )}
  </div>
)

// Shimmer skeleton rows for a table while it loads.
export const TableSkeleton = ({ columns = 6, rows = 6 }) => (
  <HScroll className="pc-table-wrap">
    <table className="pc-table">
      <tbody>
        {Array.from({ length: rows }).map((_, r) => (
          <tr key={r}>
            {Array.from({ length: columns }).map((__, c) => (
              <td key={c}>
                <span
                  className="pc-skel"
                  style={{ width: c === 0 ? "60%" : c === columns - 1 ? "40%" : "80%" }}
                />
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </HScroll>
)

// Stacked line skeletons for card bodies (detail screen loading).
export const LinesSkeleton = ({ lines = 4 }) => (
  <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
    {Array.from({ length: lines }).map((_, i) => (
      <span
        key={i}
        className="pc-skel"
        style={{ width: `${90 - i * 12}%`, height: 14 }}
      />
    ))}
  </div>
)
